import { pushToDataLayer, type CustomData } from '@helsenorge/framework-utils/adobe-analytics';

interface FormEvent extends CustomData {
  event: string;
  form: { name?: string };
}

export const trackFormEvent = (event: string, formName: string | undefined): void => {
  let formEvent: FormEvent;
  const formNameString = formName || '';

  switch (event) {
    case 'form start':
      formEvent = {
        event: 'form start',
        form: { name: formNameString },
      };
      break;
    case 'form complete':
      formEvent = {
        event: 'form complete',
        form: { name: formNameString },
      };
      break;
    case 'form save':
      formEvent = {
        event: 'form save',
        form: { name: formNameString },
      };
      break;
    case 'form continue':
      formEvent = {
        event: 'form continue',
        form: { name: formNameString },
      };
      break;
    case 'site error':
      pushToDataLayer({
        event: 'site error',
        error: {
          level: 4,
          details: 'noen av feltene er ikke fylt ut riktig',
        },
      });
      return;
    default:
      formEvent = {
        event: '',
        form: {},
      };
      break;
  }

  if (formEvent.event !== '') {
    pushToDataLayer(formEvent);
  } else {
    return;
  }
};
